import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { constructTealiumMiddleware, coreTags } from '../../core/js/middleware/analytics';
import { accountTags } from './middleware/analytics';

import accountApp from './reducers/accountApp';
import { initialState as coreInitialState } from '../../core/js/store';
import ravenMiddleware from '../../core/js/middleware/raven';
import {
    storeLogger
} from '../../core/js/middleware/logger';

export const initialState = Object.assign({}, coreInitialState, {
    core: Object.assign({}, coreInitialState.core, {
        pageType: 'account'
    }) },
    {
        account: {},
        quickshop: {}
    });

export function configureStore() {
    const tealiumMiddleware = constructTealiumMiddleware([coreTags(), accountTags()]);
    const sagaMiddleware = createSagaMiddleware();
    const createStoreWithMiddleware = createStore(
        accountApp,
        initialState,
        applyMiddleware(storeLogger('Account'), ravenMiddleware, tealiumMiddleware, sagaMiddleware)
    );
    return Object.assign({}, createStoreWithMiddleware, { runSaga: sagaMiddleware.run });
}
